<template>
	<v-layout row wrap>
		<v-flex d-flex xs1>
			<v-card color="blue" class="white--text">
				<v-card-text><strong>Lp.</strong></v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs7>
			<v-card color="blue" class="white--text">
				<v-card-text><strong>Nazwa źródła</strong></v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs4>
			<v-card color="blue" class="white--text">
				<v-card-text><strong>Wartość </strong></v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		name: "CostsSummaryHeaders",
	};
</script>
